import { z } from 'zod';
import { transformAndFilterValidItems } from '../../../common/tools/transformUtils';
import { HotspotImageSchema } from '../../../common/schemas/imageZodSchemas';

// ProductSubGroup schema for validating each product subgroup object
const ProductSubgroupBase = z.object({
    id: z.string(),
    key: z.string(),
    shortBlurb: z.string().nullable(),
    longBlurb: z.string().nullable(),
    dmDefinitionId: z.string().nullable(),
    name: z.string(),
    image: HotspotImageSchema.nullable(),
    // ProductGroupPresentation brick
    backgroundImage: HotspotImageSchema.nullable(),
    // HubspotYageoContactUsProductGroup brick (if not attached - nulls or `enabled` is false,
    // product subgroup will not be shown in the form)
    hubspotYageoContactUs_enabled: z
        .boolean()
        .nullable()
        .transform((v) => v ?? false),
    hubspotYageoContactUs_fieldValue: z.string().nullable(),
    hubspotYageoContactUs_subgroupFieldName: z.string().nullable(),
});

export const ProductSubroupSchema = ProductSubgroupBase.superRefine((data, ctx) => {
    if (
        data.hubspotYageoContactUs_enabled === true &&
        (data.hubspotYageoContactUs_fieldValue == null ||
            data.hubspotYageoContactUs_fieldValue.trim() === '')
    ) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message:
                '`hubspotYageoContactUs_fieldValue` is required when `hubspotYageoContactUs_enabled` is true.',
            path: ['hubspotYageoContactUs_fieldValue'],
        });
    }
}).describe('ProductSubGroupSchema');

// ProductGroup schema for validating product groups and their nested product subgroups
export const ProductGroupSchema = ProductSubgroupBase.extend({
    productSubgroups: z
        .array(z.unknown())
        .transform((subgroups) => transformAndFilterValidItems(ProductSubroupSchema, subgroups)),
}).describe('ProductGroupSchema');

// Main schema to validate the entire query response
export const GetProductGroupListingSchema = z
    .object({
        getObjectFolder: z.object({
            children: z
                .array(z.unknown())
                .transform((groups) => transformAndFilterValidItems(ProductGroupSchema, groups)),
        }),
    })
    .describe('GetProductGroupListingSchema');
